// extracted by mini-css-extract-plugin
module.exports = {"content":"_7a3fb80146--content--oTCcM","footer-buttons":"_7a3fb80146--footer-buttons--wKynG"};